<template>
  <v-data-table
    :headers="headers"
    :items="farms"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="Farm-button-new"
          @click="$router.push({
            name: 'processing-EditFarm'
          })"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        :data-cy="`button-Farm-edit-${item.id}`"
        @click="$router.push({
          name: 'processing-EditFarm',
          query: {id: item.id}
        })"
      >
        {{ mdiPencil }}
      </v-icon>
      <v-icon
        small
        @click="remove(item)"
        color="danger"
        :data-cy="`button-Farm-remove-${item.id}`"
      >
        {{ mdiDelete }}
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPencil, mdiDelete } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListFarm',
  module: 'Farm',
  mixins: [loading],
  data() {
    return {
      mdiPencil,
      mdiDelete,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('farms', ['farms']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('code'),
          value: 'code',
        },
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: this.$$t('address'),
          value: 'address',
        },
        {
          text: this.$$t('farmCode'),
          value: 'farmCode',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_farms();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('farms', ['LOAD_farms', 'DELETE_farm']),
    /** Delete Farm from the collection
     */
    async remove(farm) {
      const res = await this.$confirm('Are you sure you want to delete this farm?');
      if (!res) return;

      this.isLoading = true;
      await this.DELETE_farm(farm.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Farm example

'''js
<Farm />
'''
</docs>
